export * from './store'



// WEBPACK FOOTER //
// ./src/app/shared/team/index.ts